var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "720px" },
      model: {
        value: _vm.showDialog,
        callback: function ($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog",
      },
    },
    [
      !!_vm.groupData
        ? _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "dialog-header",
                  staticStyle: {
                    "background-color": "#1B6E5A",
                    color: "white",
                    "letter-spacing": "0.03rem",
                    height: "40px",
                  },
                  style: _vm.$vuetify.breakpoint.xsOnly
                    ? "text-align: center !important;"
                    : "",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(`Assign Channels - ${_vm.groupData.name}`) +
                      " "
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          icon: "",
                                          width: "24px",
                                          height: "24px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit("close")
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v(" fas fa-times "),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        931560734
                      ),
                    },
                    [_c("span", [_vm._v("Close")])]
                  ),
                ],
                1
              ),
              _c("v-card-text", { staticStyle: { "padding-inline": "4px" } }, [
                _vm.availableChannels.length > 0
                  ? _c(
                      "div",
                      { staticClass: "channel-entries" },
                      _vm._l(
                        _vm.availableChannels,
                        function (channelItem, channelIndex) {
                          return _c("subscriber-entry", {
                            key: `channel-item-key-${channelIndex}`,
                            attrs: {
                              "action-assign": "",
                              checked: _vm.groupChannels.includes(
                                channelItem.id
                              ),
                              subscriber: channelItem,
                            },
                            on: {
                              toggle: function ($event) {
                                return _vm.toggleChannelHandler(channelItem.id)
                              },
                            },
                          })
                        }
                      ),
                      1
                    )
                  : _c("div", [
                      _c(
                        "div",
                        { staticClass: "no-results mt-4 text-center" },
                        [_vm._v(" No Channels available ")]
                      ),
                    ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }